<p class="modal-title">Your dependents</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<!-- <p>Based on your inputs, Dependent {{dependent}} will be on your health insurance plan when you retire. They will be removed from this plan at age {{age}}.</p> -->

<p>Based on your inputs, a dependent (or dependents) will be on your health insurance plan when you retire.</p>
<p *ngFor="let dependent of dependents">{{dependent.label}} will be removed from this plan at age {{yearDifference + dependent.age}}.</p>
